import { mix } from "polished";
import getColor from "../getColor";
import getOnColor from "../getOnColor";
import throwError from "../throwError";

/**
 * Returns rgba color (defined in theme object) from provided borderColor and emphasis values
 *
 * @param theme - Theme object
 * @param onColor - Color of background on which is located styling element
 * @param emphasis - Emphasis of a styling element
 * @param state - State of a styling element
 * @returns Calculated rgba border color
 */
var getBorderColor = function getBorderColor(theme, onColor, emphasis) {
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "default";
  var onColorValues = getOnColor(theme, onColor);
  var colorValue = getColor(theme, onColor);
  if (!onColorValues) {
    return throwError("Passed \"".concat(onColor, "\" color doesn't have defined border colors!"));
  }
  return mix(onColorValues.emphasis[emphasis][state], onColorValues.color, colorValue);
};
export default getBorderColor;